import installmentCalculatorForm from './installment-calculator-form/installment-calculator-form.vue';
import installmentCalculatorResult from './installment-calculator-result/installment-calculator-result.vue';
import { mapState, mapActions } from 'vuex';
export default {
	props: {
		defaultAmount: {
			required: true
		},
		title: {
			required: true
		}
	},
	computed: {
		...mapState('installmentCalculator', ['durations', 'maximumAmount', 'minimumAmount', 'calculation', 'loading'])
	},
	methods: {
		...mapActions('installmentCalculator', ['init', 'calculate'])
	},
	components: {
		installmentCalculatorForm,
		installmentCalculatorResult
	},
	created() {
		this.init(this.defaultAmount);
	}
};
